import { createThemePreset } from 'projects/shared/src/lib/style/configuration/theme-color.facrory';
import { BarekaThemeColors } from 'projects/bareka/src/assets/bareka-theme.colors';

export const BarekaPreset = createThemePreset(BarekaThemeColors);
